module.exports = __webpack_public_path__ + "img/pdf-1.b9613f5f.svg";